<template>
  <div class="opportunity-info">
    <!-- 没有权限 -->
    <div v-if="!isAuth" class="no_auth">
      <img src="../assets/images/lock.png" alt="">
      <p v-if="!userId">您还未登录</p>
      <p v-else>您没有查看权限</p>
      <p v-if="!userId" class="text_2" @click="login">请登录</p>
      <p v-else class="text_3">请联系分享者 <span class="text_2" @click="login">重新登录</span></p>
    </div>

    <div v-else class="title_common_box">

      <div v-if="formData.number"
           class="brief_introduction">
        {{formData.title}}
      </div>

      <div class="view-row">
        <div class="label">商机编号：</div>
        <div class="value"><span style="font-size: 20px;color: #f56c6c;font-weight: bold">{{formData.number}}</span></div>
      </div>
      <div class="view-row">
        <div class="label">商机所属人员：</div>
        <div class="value">{{formData.opportunityOwnerName}}</div>
      </div>

      <div class="commercial_title">一、基本信息</div>
      <div class="view-row">
        <div class="label">业务类型：</div>
        <div class="value">{{formData.businessTypeLabel}}</div>
      </div>
      <div class="view-row">
        <div class="label">商品分类：</div>
        <div class="value">{{formData.commodityCategory.join('/')}}</div>
      </div>
      <div class="view-row">
        <div class="label">预计货量：</div>
        <div class="value">{{formData.estimatedQuantity}} {{formData.quantityUnit}}</div>
      </div>
      <div class="view-row">
        <div class="label">预计金额：</div>
        <div class="value">{{formData.estimatedAmount | formatWanMoney}} {{formData.currency}}</div>
      </div>
      <div class="view-row">
        <div class="label">预计项目执行日期：</div>
        <div class="value">{{formData.anyTime ? '随时' : formData.estimatedExecutionDate}}</div>
      </div>

      <div class="commercial_title">二、交易链条</div>
      <div class="view-row">
        <div class="label" style="width: 100%">全链条交易结构推进图：</div>
      </div>
      <valueChain :list="formData.opportunityProcessRoleList"
                  :disabeld="true"
                  nodeField="newUpstreamCompanyName"></valueChain>
      <div class="view-row">
        <div class="label">新结构上游公司全名：</div>
        <div class="value">{{formData.newUpstreamCompanyName}}</div>
      </div>
      <div class="view-row">
        <div class="label">新结构下游公司全名：</div>
        <div class="value">{{formData.newDownstreamCompanyName}}</div>
      </div>

      <div class="commercial_title">三、物流链条</div>
      <div class="view-row">
        <div class="label" style="width: 100%">物流过程的关键节点及名称：</div>
      </div>
      <valueChain :list="formData.opportunityLogisticsChainList"
                  :disabeld="true"
                  nodeField="estimatedLogisticsProvider"></valueChain>
      <div class="view-row">
        <div class="label">合作方提供仓储作业：</div>
        <div class="value">{{formData.partnerUnifiedWarehouseWork ? '是' : '否'}}</div>
      </div>
      <div class="view-row">
        <div class="label">预计物流商名称：</div>
        <div class="value">{{formData.estimatedLogisticsProvider}} {{formData.allowPartnerSpecifyLogistics ? '允许合作方指定物流商' : ''}}</div>
      </div>
      <div class="view-row">
        <div class="label">上游交货地点：</div>
        <div class="value">{{formData.upstreamDeliveryLocation}}</div>
      </div>
      <div class="view-row">
        <div class="label">下游交货地点：</div>
        <div class="value">{{formData.downstreamDeliveryLocation}}</div>
      </div>

      <div class="commercial_title">四、结算信息</div>
      <div class="view-row">
        <div class="label">与上游结算方式：</div>
        <div class="value">{{formData.upstreamSettlementMethods}}</div>
      </div>
      <div class="view-row">
        <div class="label">与上游货款顺序：</div>
        <div class="value">{{getSelectDesc(formData.upstreamPaymentOrder, paymentOrderList, 'value', 'label')}}</div>
      </div>
      <div class="view-row" v-if="formData.upstreamPaymentOrder === '1'">
        <div class="label">预付比例：</div>
        <div class="value">{{formData.upstreamAdvancePercentage}} %</div>
      </div>
      <div class="view-row" v-if="formData.upstreamPaymentOrder === '3'">
        <div class="label">账期天数：</div>
        <div class="value">{{formData.upstreamSettlementDays}}天</div>
      </div>
      <div class="view-row">
        <div class="label">与下游结算方式：</div>
        <div class="value">{{formData.downstreamSettlementMethods}}</div>
      </div>
      <div class="view-row">
        <div class="label">与下游货款顺序：</div>
        <div class="value">{{getSelectDesc(formData.downstreamPaymentOrder, paymentOrderList, 'value', 'label')}}</div>
      </div>
      <div class="view-row" v-if="formData.upstreamPaymentOrder === '1'">
        <div class="label">预付比例：</div>
        <div class="value">{{formData.downstreamAdvancePercentage}} %</div>
      </div>
      <div class="view-row" v-if="formData.upstreamPaymentOrder === '3'">
        <div class="label">账期天数：</div>
        <div class="value">{{formData.downstreamSettlementDays}}天</div>
      </div>

      <div class="commercial_title">五、质量与增信</div>
      <div class="view-row">
        <div class="label">质量检测报告：</div>
        <div class="value">{{formData.qualityInspectionReport ? ' 是' : '否'}}</div>
      </div>
      <div class="view-row">
        <div class="label">货物购买保险：</div>
        <div class="value">{{formData.goodsInsurance ? ' 是' : '否'}}</div>
      </div>
      <div class="view-row">
        <div class="label">上游履约保险：</div>
        <div class="value">{{formData.upstreamInsurance ? ' 是' : '否'}}</div>
      </div>
      <div class="view-row">
        <div class="label">下游信用保险：</div>
        <div class="value">{{formData.downstreamCreditInsurance ? ' 是' : '否'}}</div>
      </div>
      <div class="view-row">
        <div class="label">股东等担保：</div>
        <div class="value">{{formData.shareholderGuarantee ? ' 是' : '否'}}</div>
      </div>

      <div class="commercial_title">六、附件</div>
      <fileList :fileList="formData.attachmentUrls"
                billType="settleContract"
                :billsId="formData.id"
                :showAdd="false"
                :disabled="formData.status === 3"
                :kernelId="1003"
                :clientId="1003"></fileList>

      <div class="commercial_title">七、总体分析</div>
      <div v-html="formData.overallAnalysis"></div>
    </div>


    <van-dialog v-model="dialogshow"
                title="手机验证码登录"
                confirmButtonText="登录"
                confirmButtonColor="#1989fa"
                @confirm="$refs.login.onSubmit()">
      <login @success="
          dialogshow = false;
          mobile = true;
          loginSuccessHandle()
        "
               ref="login"></login>
    </van-dialog>

  </div>
</template>

<script>
import valueChain from '@/components/value-chain'
import fileList from "@/components/fileList"
import login from "./login"

export default {
  components: {
    valueChain,
    fileList,
    login
  },
  data () {
    return {
      dialogshow: false,
      businessTypeList: [
        {key: 'intradomestic', desc: '内贸'},
        {key: 'import', desc: '进口'},
        {key: 'export', desc: '出口'}
      ],
      opportunityPermissionList: [
        {label: '登录可见', value: 'all'},
        {label: '分享关闭', value: 'none'},
        {label: '部分人员可见', value: 'partial'},
        {label: '游客可见', value: 'guest'},
      ],
      paymentOrderList: [
        {label: '预付款', value: '1'},
        {label: '装完货即付款', value: '2'},
        {label: '有账期', value: '3'}
      ],
      loadState: false,
      formData: {},
      isAuth: false,
      userId: this.$cookies.get("userId"),
      isOuter: this.$cookies.get("isOuter"),
    }
  },
  filters: {
    formatWanMoney (num) {
      if (isNaN(num)) {
        return ''
      }
      num = Number((num / 10000).toFixed(2))
      if (!/^(\+|-)?(\d+)(,\d{3})*(\.|\.\d+)?$/.test(num)) {
        return num
      }
      let re = /(\d)(\d{3})(,|$)/, a = RegExp.$1, b = RegExp.$2, c = RegExp.$4
      while (re.test(b)) {
        b = b.replace(re, '$1,$2$3')
      }
      let value = a + '' + b + '' + c
      return value + '万'
    },
  },
  computed: {
  },
  mounted () {
    this.wxLogin()
    let id = this.$route.query.id
    if (id) {
      this.getObject(id)
    }
  },
  methods: {
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    wxLogin () {
      if (this.getQueryVariable("code")) {
        this.$api
          .post("/api/wechat/getH5UserInfo", {
            tenantId: 1065289555902464,
            code: this.getQueryVariable("code"),
            pid: null,
            ladingPageId: 0
          })
          .then((res) => {
            this.$cookies.set("unionId", res.result.unionId);
            this.$cookies.set("openId", res.result.openId);
            this.$cookies.set(`token_1065289555902464`, res.result.token, "12h");
            this.$cookies.set("mobile", res.result.mobile || '');
            this.$cookies.set("headpic", res.result.headPic);
            this.$cookies.set("nickname", res.result.nickname);
            window.location.href = window.location.origin + window.location.pathname + window.location.hash
          });
      } else if (!this.$cookies.get(`token_1065289555902464`)) {
        this.$api
          .get("/api/wechat/getAuthorizeUrl", {
            url: window.location.href
          })
          .then((res) => {
            if (process.env.NODE_ENV != 'development') {
              window.location.href = res.result;
            } else { // 本地写死用户信息
              this.$cookies.set("unionId", '');
              this.$cookies.set("openId", 'oyODKwPV1l46Tg8zxEurBdq3EH7o');
              this.$cookies.set(`token_1065289555902464`, '88888', "12h");
              this.$cookies.set("headpic", '');
              this.$cookies.set("nickname", '张小菇');
              this.$cookies.set("mobile", '13076997010');
              window.location.href = window.location.origin + window.location.pathname + window.location.hash
            }
          });
      }
    },
    share () {
      this.$api
        .get("/api/wechat/share/get", {
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          console.log('分享数据获取：', res.result)
          let that = this
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.result.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.result.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
            signature: res.result.signature, // 必填，签名，见附录1
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "hideMenuItems",
              "showMenuItems",
              "hideAllNonBaseMenuItem",
              "showAllNonBaseMenuItem",
              "translateVoice",
              "startRecord",
              "stopRecord",
              "onVoiceRecordEnd",
              "playVoice",
              "onVoicePlayEnd",
              "pauseVoice",
              "stopVoice",
              "uploadVoice",
              "downloadVoice",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "getNetworkType",
              "openLocation",
              "getLocation",
              "hideOptionMenu",
              "showOptionMenu",
              "closeWindow",
              'updateTimelineShareData',
              "scanQRCode",
              "chooseWXPay",
              "openProductSpecificView",
              "addCard",
              "chooseCard",
              "openCard",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });

          wx.ready(function () {
            let shareUrl = window.location.origin + window.location.pathname + `#/opportunity-info?id=${that.formData.id}`
            let logo = 'http://www.zhongpukeji.cn/img/icon/opportunity.png'
            // let logo = require('@/assets/images/opp.png')
            let amount = that.formData.estimatedAmount ? that.formData.estimatedAmount / 10000 : ''
            let desc = `业务类型：${that.formData.businessTypeLabel}\n预计货值：${amount}万${that.formData.currency}`
            wx.onMenuShareAppMessage({
              title: that.formData.title, // 分享标题
              desc, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: logo, // 分享图标
              success: function (res) {
                console.log('分享回调onMenuShareAppMessage：', JSON.stringify(res))
              }
            });
            wx.onMenuShareTimeline({
              title: that.formData.title, // 分享标题
              desc, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: logo, // 分享图标
              success: function (res) {
                console.log('分享回调onMenuShareTimeline：', JSON.stringify(res))
              }
            })
            wx.updateTimelineShareData({
              title: that.formData.title, // 分享标题
              desc, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: logo, // 分享图标
              success: function (res) {
                console.log('分享回调updateTimelineShareData：', JSON.stringify(res))
              }
            })
            //分享给好友
            wx.updateAppMessageShareData({
              title: that.formData.titlee, // 分享标题
              desc, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: logo, // 分享图标
              success: function (res) {
                console.log('分享回调updateAppMessageShareData：', JSON.stringify(res))
              }
            })
          });
          wx.error(function (res) {
            console.log('打印错误消息:', res.errMsg); //打印错误消息。及把 debug:false,设置为debug:ture就可以直接在网页上看到弹出的错误提示
          });

        })
    },
    getSelectDesc (value, list, id = 'id', name = 'name') {
      let ind = list.findIndex((item) => item[id] === value)
      if (ind > -1) {
        return list[ind][name]
      } else {
        return ''
      }
    },
    login () {
      this.dialogshow = true
    },
    loginSuccessHandle () {
      this.userId = this.$cookies.get("userId")
      this.isOuter = this.$cookies.get("isOuter")
      this.getAuth()
    },
    getAuth () {
      let role = ''
      if (!this.userId) {
        role = 'guest' // 游客
      } else if (this.formData.opportunityOwner == this.userId || this.formData.createById == this.userId) {
        role = 'mine' // 商机所属人
      } else if (this.formData.opportunityAuthorityList.find(item => item.personId == this.userId)) {
        role = 'part' // 商机参与人
      } else {
        role = 'other' // 其余登录者
      }

      if (this.isOuter === '0') { // 内部用户
        this.isAuth = true
      }
      if (this.formData.opportunityPermission === 'guest') { // 游客可见
        this.isAuth = true
      } else if (this.formData.opportunityPermission === 'all' && role !== 'guest') { // 登录可见
        this.isAuth = true
      } else if (this.formData.opportunityPermission === 'partial' && (role === 'mine' || role === 'part')) { // 部分可见
        this.isAuth = true
      } else if (this.formData.opportunityPermission === 'none' && role === 'mine') { // 分享关闭
        this.isAuth = true
      }
      if (role === 'guest' && !this.isAuth) {
        // 弹出登录框
        this.dialogshow = true
      }
    },
    getObject (id) {
      this.loadState = true
      this.$api
      .get("/crmapi/crm/commercialOpportunity/frontGet", {
          id
      })
        .then((res) => {
          if (res.code === 'C0000') {
            if (res.result) {
              let dataObj = res.result || {}
              dataObj.commodityCategory = []
              if (dataObj.commodityCategoryMajor) {
                dataObj.commodityCategory.push(dataObj.commodityCategoryMajor)
                if (dataObj.commodityCategoryMinor) {
                  dataObj.commodityCategory.push(dataObj.commodityCategoryMinor)
                }
              }
              try {
                dataObj.attachmentUrls = dataObj.attachmentUrls ? JSON.parse(dataObj.attachmentUrls) : []
              } catch (e) {
                dataObj.attachmentUrls = dataObj.attachmentUrls ? dataObj.attachmentUrls.split(',').map(item => {
                  return {url: item, name: '附件名称'}
                }) : []
              }
              if (!dataObj.estimatedExecutionDate) {
                dataObj.anyTime = true
              }
              dataObj.businessTypeLabel = this.getSelectDesc(dataObj.businessType, this.businessTypeList, 'key', 'desc')
              
              this.formData = dataObj

              this.share()

              this.getAuth()
            }
          } else {
            this.$toast(res.message)
          }
        })
        .finally(() => {
          this.loadState = false
        })
    }
  }
}
</script>

<style lang="less">
.no_auth{
  text-align: center;
  font-size: 34px;
  color: #000;
  padding: 100px 0;
  border-radius: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  p{
    margin: 20px 0;
  }
  .text_2{
    color: #0068B7;
    text-decoration: underline;
    font-size: 28px;
  }
  .text_3{
    color: #888;
    font-size: 30px;
  }
  img{
    width: 70px;
  }
}
.opportunity-info{
  padding: 20px;
  font-size: 28px;
  .commercial_title{
    color: #0068B7;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px solid #e8ecf0;
  }
  .brief_introduction{
    font-size: 32px;
    font-weight: bold;
  }
  .view-row{
    margin: 20px 0;
    display: flex;
    .label{
      color: #999;
      width: 260px;
      font-size: 26px;
    }
    .value{
      color: #000;
      flex: 1;
    }
  }

  .el-form-item__content{
    .view{
      font-size: 32px;
    }
  }
  .push_record{
    font-size: 14px;
    padding: 20px;
  }
  .view_record{
    padding: 0 0 14px 20px;
    span{
      margin-right: 20px;
    }
  }
  .more{
    padding: 0 0 14px 20px;
    color: #0068B7;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>